import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { BaseComponent } from '../components/base/base.component';
import { Router } from '@angular/router';
import { subModule } from 'src/app/authentication/models/sign-in';
import { permissionTypes } from '../enums/permission';
import { SharedService } from './shared.service';
import { AbstractControl, ValidationErrors } from '@angular/forms';

interface PermissionCheckResult {
  canEdit: boolean;
  canCreate: boolean;
  canDelete: boolean;
  canView: boolean;
  canApporval: boolean;
}
@Injectable({
  providedIn: 'root'
})

export class CommonService extends BaseComponent {
  default_currency: any;
  default_currency_symbol: any;
  formattedDate: any;
  dateFormat: string | undefined;
  permissions: any[];
  validPermissionFound: boolean = false;
  private hourMinuteRegex: RegExp = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
  private decimalRegex: RegExp = /^(\d+)?(\.\d+)?$/;
  private looseHourMinuteRegex: RegExp = /^(\d+):(\d+)$/;
  private timesheetFormat: number;

  constructor(
    public router: Router,
    private sharedService: SharedService
  ) {
    super();
    setTimeout(() => {
      this.timesheetFormat = this.sharedService.timesheet_format;
      console.log(this.timesheetFormat, 'Getting Timesheet Format 1')
    }, 500);
  }

  ngOnInit(): void {
    this.timesheetFormat = this.sharedService.timesheet_format;
    console.log(this.timesheetFormat, 'Getting Timesheet Format 2')
  }

  isAuthenticated(): boolean {
    var token = localStorage.getItem("tokenInfo") ? JSON.parse(localStorage.getItem("tokenInfo") as any).access : null;
    if (token)
      return true;
    else
      return false;
  }

  isUserAuthenticated(): boolean {
    var user_token = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo") as any) : null;
    if (user_token)
      return true;
    else
      return false;
  }

  getBaseURL(): string {
    return environment.baseURL;
  }

  getPermissions() {
    let permissions = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo") as any) : null;
    return this.permissions = permissions?.permissions;
  }

  // async checkPermission(): Promise<any> {
  //   const permissions = this.getPermissions();
  //   for (let permission of permissions) {
  //     for (let subModule of permission.sub_modules) {
  //       if (subModule.permission_type_id !== 1) {
  //         if (subModule.sub_module_name.toLowerCase() === this.subModules.analytical) {
  //           return this.router.navigate([this.routingModuleType.dashboard, this.routingDashboardModuleType.analytics]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.saas) {
  //           return this.router.navigate([this.routingModuleType.dashboard, this.routingDashboardModuleType.saas]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.sales) {
  //           return this.router.navigate([this.routingModuleType.dashboard, this.routingDashboardModuleType.sales]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.clients) {
  //           return this.router.navigate([this.routingModuleType.interactions, this.routingInteractionsModuleType.clients]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.contacts) {
  //           return this.router.navigate([this.routingModuleType.interactions, this.routingInteractionsModuleType.contacts]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.quotes) {
  //           return this.router.navigate([this.routingModuleType.business, this.routingBusinessModuleType.quotes]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.invoices) {
  //           return this.router.navigate([this.routingModuleType.business, this.routingBusinessModuleType.quotes]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.jobs) {
  //           return this.router.navigate([this.routingModuleType.collaboration, this.routingCollaborationModuleType.jobs]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.timesheet) {
  //           return this.router.navigate([this.routingModuleType.collaboration, this.routingCollaborationModuleType.timesheets]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.settings) {
  //           return this.router.navigate([this.routingModuleType.organization, this.routingOrganizationSubModuleType.settings]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.number_sequences) {
  //           return this.router.navigate([this.routingModuleType.organization, this.routingOrganizationSubModuleType.number_sequences]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.client_types) {
  //           return this.router.navigate([this.routingModuleType.organization, this.routingOrganizationSubModuleType.client_types]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.quotes) {
  //           return this.router.navigate([this.routingModuleType.organization, this.routingOrganizationSubModuleType.quotes]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.Staffs) {
  //           return this.router.navigate([this.routingModuleType.organization, this.routingOrganizationSubModuleType.staffs]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.tasks) {
  //           return this.router.navigate([this.routingModuleType.organization, this.routingOrganizationSubModuleType.tasks]);
  //         } else if (subModule.sub_module_name.toLowerCase() === this.subModules.expenses) {
  //           return this.router.navigate([this.routingModuleType.organization, , this.routingOrganizationSubModuleType.expenses]);
  //         } else {
  //           this.router.navigate([this.routingModuleType.accessdenied]);
  //         }
  //       }
  //     }
  //   }
  // }

  async checkPermission(): Promise<any> {
    const permissions = this.getPermissions();
    const subModuleRoutes: any = {
      'saas': [this.routingModuleType.dashboard, this.routingDashboardModuleType.saas],
      'analytical': [this.routingModuleType.dashboard, this.routingDashboardModuleType.analytics],
      'sales': [this.routingModuleType.dashboard, this.routingDashboardModuleType.sales],
      'clients': [this.routingModuleType.interactions, this.routingInteractionsModuleType.clients],
      'contacts': [this.routingModuleType.interactions, this.routingInteractionsModuleType.contacts],
      'quotes': [this.routingModuleType.business, this.routingBusinessModuleType.quotes],
      'invoices': [this.routingModuleType.business, this.routingBusinessModuleType.invoices],
      'Payments': [this.routingModuleType.business, this.routingBusinessModuleType.payments],
      'Adjustments': [this.routingModuleType.business, this.routingBusinessModuleType.adjustments],
      'jobs': [this.routingModuleType.collaboration, this.routingCollaborationModuleType.jobs],
      'timesheet': [this.routingModuleType.collaboration, this.routingCollaborationModuleType.timesheets],
      'settings': [this.routingModuleType.organization, this.routingOrganizationSubModuleType.settings],
      'number_sequences': [this.routingModuleType.organization, this.routingOrganizationSubModuleType.number_sequences],
      'client_types': [this.routingModuleType.organization, this.routingOrganizationSubModuleType.client_types],
      'staffs': [this.routingModuleType.organization, this.routingOrganizationSubModuleType.staffs],
      'tasks': [this.routingModuleType.organization, this.routingOrganizationSubModuleType.tasks],
      'costs': [this.routingModuleType.organization, this.routingOrganizationSubModuleType.costs],
      'roles': [this.routingModuleType.organization, this.routingOrganizationSubModuleType.roles],
      'Custom Fields': [this.routingModuleType.features, this.subModules.custom_fields],
      'Custom Templates': [this.routingModuleType.features, this.subModules.custom_templates],
      'Invoice Templates': [this.routingModuleType.features, this.subModules.invoice_templates],
    };

    this.validPermissionFound = false;

    for (let permission of permissions) {
      for (let subModule of permission.sub_modules) {
        if (subModule.permission_type_id !== 1) {
          const subModuleName = subModule.sub_module_name.toLowerCase();
          if (subModuleRoutes[subModuleName]) {
            this.validPermissionFound = true;
            return this.router.navigate(subModuleRoutes[subModuleName]);
          }
        }
      }
    }

    if (!this.validPermissionFound) {
      return this.router.navigate([this.routingModuleType.accessdenied]);
    }
  }


  permissionCheck(module: any, subModule: any): PermissionCheckResult {
    let canEdit = false;
    let canDelete = false;
    let canCreate = false;
    let canView = false;
    let canApporval = false;

    const permissionMap: { [key: number]: { canCreate: boolean, canEdit: boolean, canView: boolean, canDelete: boolean, canApporval: boolean } } = {
      [permissionTypes.create_edit_access]: { canCreate: true, canEdit: true, canView: false, canDelete: true, canApporval: false },
      [permissionTypes.view_only_access]: { canCreate: false, canEdit: false, canView: true, canDelete: true, canApporval: false },
      [permissionTypes.full_access]: { canCreate: false, canEdit: false, canView: false, canDelete: false, canApporval: false },
      [permissionTypes.no_access]: { canCreate: true, canEdit: true, canView: true, canDelete: true, canApporval: false },
      [permissionTypes.enabled]: { canCreate: false, canEdit: false, canView: false, canDelete: false, canApporval: true },
    };

    for (const permission of this.permissions) {
      if (permission.name.toLowerCase() === module.toLowerCase()) {
        const subModulePermission = permission.sub_modules.find((sub: any) => sub.sub_module_name.toLowerCase() === subModule.toLowerCase());
        if (subModulePermission) {
          const { canCreate: newCanCreate, canEdit: newCanEdit, canView: newCanView, canDelete: newCanDelete, canApporval: newApproval } = permissionMap[subModulePermission.permission_type_id] || {};
          canCreate = newCanCreate ?? canCreate;
          canEdit = newCanEdit ?? canEdit;
          canView = newCanView ?? canView;
          canDelete = newCanDelete ?? canDelete;
          canApporval = newApproval ?? canApporval
        }
      }
    }

    return { canEdit, canDelete, canCreate, canView, canApporval };
  }



  // permissionCheck(module: any, subModule: any): PermissionCheckResult {
  //   let canEdit = false;
  //   let canDelete = false;
  //   let canCreate = false;
  //   let canView = false;

  //   this.permissions.forEach((permission: any) => {
  //     if (permission.name.toLowerCase() === module.toLowerCase()) {
  //       permission.sub_modules.forEach((sub: subModule) => {
  //         if (sub.sub_module_name.toLowerCase() === subModule.toLowerCase()) {
  //           if ([permissionTypes.create_edit_access].includes(sub.permission_type_id)) {
  //             canDelete = true;
  //           }

  //           if ([permissionTypes.view_only_access].includes(sub.permission_type_id)) {
  //             canView = true;
  //             canDelete = true;
  //           }

  //           if ([permissionTypes.full_access].includes(sub.permission_type_id)) {
  //             canCreate = false;
  //             canEdit = false;
  //             canView = false;
  //             canDelete = false;
  //           }

  //           if ([permissionTypes.no_access].includes(sub.permission_type_id)) {
  //             canCreate = true;
  //             canEdit = true;
  //             canView = true;
  //             canDelete = true;
  //           }
  //         }
  //       });
  //     }
  //   });

  //   return { canEdit, canDelete, canCreate, canView };
  // }

  //Menu Hide Process
  menuPermission(menu: any) {
    this.permissions.forEach((permission: any) => {
      let l1 = menu.filter((f: any) => f.module_id === permission.module_id);
      if (l1.length > 0) {
        permission.sub_modules.forEach((subModule: any) => {
          let l2 = l1[0].items.filter((f: any) => f.sub_module_id === subModule.sub_module_id);
          if (l2.length > 0 && subModule.permission_type_id === permissionTypes.no_access) {
            l2[0].visible = false;
          }
        });
        let allSubItemsInvisible = l1[0].items.every((item: any) => item.visible === false);
        if (allSubItemsInvisible) {
          l1[0].visible = false;
        }
      }
    });
    return menu;
  }

  getversion(): string {
    return '1.0';
  }

  getpoweredbyversion(): string {
    return '2024-25';
  }

  getTimesheetFormat(): number {
    return this.timesheetFormat;
  }

  getDefaultValue(): string {
    return this.timesheetFormat == 1 ? '00:00' : '0.0';
  }

  timeFormatValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
    const isValid = this.timesheetFormat == 1
      ? this.hourMinuteRegex.test(value)
      : this.decimalRegex.test(value);
    return isValid ? null : { invalidFormat: true };
  }

  timeFormatOthersValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;
    const isValid = this.hourMinuteRegex.test(value)
    return isValid ? null : { invalidFormat: true };
  }

  validateAndConvertTime(controlOrValue: AbstractControl | any, module?: any): any {
  let value: any;
  let isControl = false;

  if (controlOrValue && typeof controlOrValue === 'object' && 'value' in controlOrValue) {
    isControl = true;
    value = controlOrValue.value;
  } else {
    value = controlOrValue;
  }

  const convertedValue = module === 'timesheet'
    ? this.convertTimeFormat(value)
    : this.timeFormatConvert(value);

  if (isControl && convertedValue !== value) {
    controlOrValue.setValue(convertedValue);
    controlOrValue.updateValueAndValidity();
    return;
  }

  return convertedValue;
}


   timeFormatConvert(value: string): string {
    if (!value) return value;

    if (this.decimalRegex.test(value) || /^(0|[1-9]\d*)(\.\d{1,2})?$/.test(value) || /^(\d+)?(\.\d{1,2})?$/.test(value)) {
        let decimal = parseFloat(value);
        if (isNaN(decimal)) return this.getDefaultValue();
        decimal = Math.round(decimal * 60) / 60;
        const hours = Math.floor(decimal);
        const minutes = Math.round((decimal - hours) * 60);
        return `${this.padZero(hours)}:${this.padZero(minutes % 60)}`;
      }
      return value
   }

  convertTimeFormat(value: string): string {
    if (!value) return value;

    if (this.timesheetFormat == 1) {
      if (this.decimalRegex.test(value) || /^\d+(\.\d+)?$/.test(value)) {
        let decimal = parseFloat(value);
        if (isNaN(decimal)) return this.getDefaultValue();
        decimal = Math.round(decimal * 60) / 60;
        const hours = Math.floor(decimal);
        const minutes = Math.round((decimal - hours) * 60);
        return `${this.padZero(hours)}:${this.padZero(minutes % 60)}`;
      } else if (this.looseHourMinuteRegex.test(value)) {
        const match = value.match(this.looseHourMinuteRegex);
        if (match) {
          let hours = parseInt(match[1], 10);
          let minutes = parseInt(match[2], 10);
          const totalMinutes = hours * 60 + minutes;
          const roundedMinutes = Math.round(totalMinutes / 15) * 15;
          hours = Math.floor(roundedMinutes / 60);
          minutes = roundedMinutes % 60;
          return `${this.padZero(hours)}:${this.padZero(minutes)}`;
        }
      }
    } else {
      if (this.hourMinuteRegex.test(value) || this.looseHourMinuteRegex.test(value)) {
        const match = value.match(this.looseHourMinuteRegex);
        if (match) {
          let hours = parseInt(match[1], 10);
          let minutes = parseInt(match[2], 10);
          const totalMinutes = hours * 60 + minutes;
          const decimal = totalMinutes / 60;
          return decimal.toFixed(2);
        }
      } else if (/^\d+(\.\d+)?$/.test(value)) {
        const decimal = parseFloat(value);
        if (isNaN(decimal)) return this.getDefaultValue();
        return decimal.toFixed(2);
      }
    }
    return value;
  }

  toBackendFormat(value: string): string {
    if (this.timesheetFormat == 1 && (this.hourMinuteRegex.test(value) || this.looseHourMinuteRegex.test(value))) {
      const match = value.match(this.looseHourMinuteRegex);
      if (match) {
        const hours = parseInt(match[1], 10);
        const minutes = parseInt(match[2], 10);
        const decimal = hours + minutes / 60;
        return decimal.toFixed(2);
      }
    }
    if (this.decimalRegex.test(value) || /^\d+(\.\d+)?$/.test(value)) {
      const decimal = parseFloat(value);
      return isNaN(decimal) ? '0.00' : decimal.toFixed(2);
    }
    return value;
  }

  private padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }
}